<p>fit-bit-update-token works!</p>
<button (click)="updateToken()">Update Token</button>
Token: {{token}}